var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashboardaverageloansize(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.7113 7.90572C18.1667 6.45033 18.1667 4.09068 16.7113 2.63529C15.2559 1.1799 12.8963 1.1799 11.4409 2.63529C9.98549 4.09068 9.98549 6.45033 11.4409 7.90572C12.8963 9.36111 15.2559 9.36111 16.7113 7.90572Z",
    fill: "#F9B256"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.142 5.27129C17.142 6.96359 15.7698 8.3358 14.0775 8.3358C12.3847 8.3358 11.013 6.96359 11.013 5.27129C11.013 3.57899 12.3847 2.20679 14.0775 2.20679C15.7698 2.20679 17.142 3.57899 17.142 5.27129Z",
    fill: "#FFE167"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0775 8.45859C12.3199 8.45859 10.8903 7.02894 10.8903 5.27135C10.8903 3.51375 12.3204 2.08411 14.0775 2.08411C15.8346 2.08411 17.2647 3.51375 17.2647 5.27135C17.2647 7.02894 15.8351 8.45859 14.0775 8.45859ZM14.0775 2.32958C12.4554 2.32958 11.1357 3.64925 11.1357 5.27135C11.1357 6.89344 12.4554 8.21311 14.0775 8.21311C15.6996 8.21311 17.0193 6.89344 17.0193 5.27135C17.0193 3.64925 15.6996 2.32958 14.0775 2.32958Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9911 4.16231L13.3524 4.48976L13.1123 4.06952L14.106 3.45288H14.6406V6.47713L15.2087 6.50462V6.96857H13.3087V6.52131L13.8325 6.48842C13.9361 6.48302 13.9906 6.44473 13.9906 6.30824L13.9911 4.16231Z",
    fill: "#FBCB43"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0774 7.80859H9.30933V10.7562H14.0774V7.80859Z",
    fill: "#E57368"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1852 7.9328L14.0774 7.80859V10.7562L19.1852 10.8805V7.9328Z",
    fill: "#D3362D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M3.46265 30.6047V35.987H9.81012V34.496C7.32052 33.7434 5.1358 32.382 3.46265 30.6047Z",
    fill: "#E57368"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M8.1856 10.2516L3.22604 9.03796C2.48667 8.8568 1.74092 9.30945 1.56025 10.0488L1.50281 16.2397C2.93147 13.622 5.29048 11.5055 8.1856 10.2516Z",
    fill: "#E57368"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M8.18559 10.2516C5.29095 11.5059 2.93145 13.6219 1.5023 16.2397C0.542989 17.9968 0 19.9773 0 22.0756C0 25.336 1.30641 28.315 3.46266 30.6048C5.13581 32.3821 7.32054 33.744 9.81014 34.4961C11.1553 34.9026 12.5884 35.1328 14.0775 35.1535V8.99768C11.9713 9.02665 9.97706 9.47537 8.18559 10.2516Z",
    fill: "#ED9C98"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9457 34.4465V35.9871H25.2932V30.434C23.6362 32.2569 21.4476 33.659 18.9457 34.4465Z",
    fill: "#D3362D"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9992 16.0762L26.9408 9.81512C26.7596 9.07575 26.0139 8.62309 25.2745 8.80376L20.0253 10.0886C23.0328 11.2943 25.4979 13.4192 26.9992 16.0762Z",
    fill: "#D3362D"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9992 16.0761C25.4979 13.4191 23.0328 11.2942 20.0253 10.089C18.2706 9.38544 16.3339 8.99268 14.2959 8.99268C14.2228 8.99268 14.1506 8.9971 14.0775 8.99808V35.1534C14.1501 35.1544 14.2228 35.1583 14.2959 35.1583C15.9244 35.1583 17.4871 34.9055 18.9457 34.4469C21.4476 33.6594 23.6367 32.2573 25.2932 30.4339C27.3527 28.1672 28.5924 25.2539 28.5924 22.076C28.5924 19.9119 28.015 17.8735 26.9992 16.0761Z",
    fill: "#E57368"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4092 18.7008C11.4092 19.8943 10.6988 20.862 9.82192 20.862C8.94557 20.862 8.23468 19.8938 8.23468 18.7008C8.23468 17.5068 8.94557 16.5397 9.82192 16.5397C10.6988 16.5392 11.4092 17.5068 11.4092 18.7008Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4459 19.2747C10.4459 19.6523 10.1715 19.9586 9.83322 19.9586C9.49545 19.9586 9.22101 19.6523 9.22101 19.2747C9.22101 18.8967 9.49545 18.5908 9.83322 18.5908C10.172 18.5903 10.4459 18.8967 10.4459 19.2747Z",
    fill: "#999999"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8059 18.7008C19.8059 19.8943 19.0955 20.862 18.2186 20.862C17.3418 20.862 16.6314 19.8938 16.6314 18.7008C16.6314 17.5068 17.3418 16.5397 18.2186 16.5397C19.0955 16.5392 19.8059 17.5068 19.8059 18.7008Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8426 19.2747C18.8426 19.6523 18.5682 19.9586 18.2299 19.9586C17.8921 19.9586 17.6172 19.6523 17.6172 19.2747C17.6172 18.8967 17.8916 18.5908 18.2299 18.5908C18.5686 18.5903 18.8426 18.8967 18.8426 19.2747Z",
    fill: "#999999"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M9.20972 25.9128C9.20972 28.2944 11.389 30.2253 14.078 30.2253V21.6003C11.389 21.6003 9.20972 23.5312 9.20972 25.9128Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9456 25.9128C18.9456 23.5308 16.7658 21.6003 14.0774 21.6003V30.2253C16.7658 30.2253 18.9456 28.2944 18.9456 25.9128Z",
    fill: "#FCCDBE"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8422 27.449C12.4691 27.449 12.9773 26.755 12.9773 25.899C12.9773 25.043 12.4691 24.3491 11.8422 24.3491C11.2153 24.3491 10.7072 25.043 10.7072 25.899C10.7072 26.755 11.2153 27.449 11.8422 27.449Z",
    fill: "#ED9C98"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4479 25.899C17.4479 26.7553 16.9397 27.449 16.3128 27.449C15.6859 27.449 15.1777 26.7553 15.1777 25.899C15.1777 25.0428 15.6859 24.3491 16.3128 24.3491C16.9402 24.3491 17.4479 25.0428 17.4479 25.899Z",
    fill: "#E57368"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6103 34.6443H33.0172V35.8761H33.6103V34.6443Z",
    fill: "#F9B256"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0525 34.6443H29.4599V35.8761H30.0525V34.6443Z",
    fill: "#F9B256"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4242 34.6443H31.8316V35.8761H32.4242V34.6443Z",
    fill: "#F9B256"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2381 34.6443H30.6455V35.8761H31.2381V34.6443Z",
    fill: "#F9B256"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M34.796 34.6443H34.2029V35.8761H34.796V34.6443Z",
    fill: "#F9B256"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8668 34.6443H28.2737V35.8761H28.8668V34.6443Z",
    fill: "#F9B256"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2737 34.6443H27.6807V35.8761H28.2737V34.6443Z",
    fill: "#FFE167"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4598 34.6443H28.8668V35.8761H29.4598V34.6443Z",
    fill: "#FFE167"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6455 34.6443H30.0524V35.8761H30.6455V34.6443Z",
    fill: "#FFE167"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8317 34.6443H31.2386V35.8761H31.8317V34.6443Z",
    fill: "#FFE167"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0173 34.6443H32.4242V35.8761H33.0173V34.6443Z",
    fill: "#FFE167"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2029 34.6443H33.6104V35.8761H34.2029V34.6443Z",
    fill: "#FFE167"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M35.3885 34.6443H34.796V35.8761H35.3885V34.6443Z",
    fill: "#FFE167"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M35.389 34.6443V35.8761H27.6806V34.6443H35.389ZM35.6188 34.415H35.389H27.6806H27.4509V34.6448V35.8766V36.1064H27.6806H35.389H35.6188V35.8766V34.6448V34.415Z",
    fill: "#F5B400"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4994 33.17H33.9069V34.4018H34.4994V33.17Z",
    fill: "#F9B256"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9416 33.17H30.349V34.4018H30.9416V33.17Z",
    fill: "#F9B256"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3133 33.17H32.7207V34.4018H33.3133V33.17Z",
    fill: "#F9B256"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M32.1277 33.17H31.5351V34.4018H32.1277V33.17Z",
    fill: "#F9B256"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6851 33.17H35.0925V34.4018H35.6851V33.17Z",
    fill: "#F9B256"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7559 33.17H29.1633V34.4018H29.7559V33.17Z",
    fill: "#F9B256"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1628 33.17H28.5703V34.4018H29.1628V33.17Z",
    fill: "#FFE167"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3489 33.17H29.7559V34.4018H30.3489V33.17Z",
    fill: "#FFE167"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5351 33.17H30.942V34.4018H31.5351V33.17Z",
    fill: "#FFE167"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M32.7208 33.17H32.1277V34.4018H32.7208V33.17Z",
    fill: "#FFE167"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9069 33.17H33.3138V34.4018H33.9069V33.17Z",
    fill: "#FFE167"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0925 33.17H34.4995V34.4018H35.0925V33.17Z",
    fill: "#FFE167"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M36.2781 33.17H35.6855V34.4018H36.2781V33.17Z",
    fill: "#FFE167"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M36.2782 33.1699V34.4017H28.5703V33.1699H36.2782ZM36.5079 32.9407H36.2782H28.5703H28.3405V33.1704V34.4022V34.632H28.5703H36.2782H36.5079V34.4022V33.1704V32.9407Z",
    fill: "#F5B400"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4994 28.6985H33.9069V29.9303H34.4994V28.6985Z",
    fill: "#F9B256"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9416 28.6985H30.349V29.9303H30.9416V28.6985Z",
    fill: "#F9B256"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3133 28.6985H32.7207V29.9303H33.3133V28.6985Z",
    fill: "#F9B256"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M32.1277 28.6985H31.5351V29.9303H32.1277V28.6985Z",
    fill: "#F9B256"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6851 28.6985H35.0925V29.9303H35.6851V28.6985Z",
    fill: "#F9B256"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7559 28.6985H29.1633V29.9303H29.7559V28.6985Z",
    fill: "#F9B256"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1628 28.6985H28.5703V29.9303H29.1628V28.6985Z",
    fill: "#FFE167"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3489 28.6985H29.7559V29.9303H30.3489V28.6985Z",
    fill: "#FFE167"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5351 28.6985H30.942V29.9303H31.5351V28.6985Z",
    fill: "#FFE167"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M32.7208 28.6985H32.1277V29.9303H32.7208V28.6985Z",
    fill: "#FFE167"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9069 28.6985H33.3138V29.9303H33.9069V28.6985Z",
    fill: "#FFE167"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0925 28.6985H34.4995V29.9303H35.0925V28.6985Z",
    fill: "#FFE167"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M36.2781 28.6985H35.6855V29.9303H36.2781V28.6985Z",
    fill: "#FFE167"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M36.2782 28.6984V29.9302H28.5703V28.6984H36.2782ZM36.5079 28.4686H36.2782H28.5703H28.3405V28.6984V29.9302V30.1599H28.5703H36.2782H36.5079V29.9302V28.6984V28.4686Z",
    fill: "#F5B400"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0855 31.6947H32.4924V32.9265H33.0855V31.6947Z",
    fill: "#F9B256"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5276 31.6947H28.9345V32.9265H29.5276V31.6947Z",
    fill: "#F9B256"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8989 31.6947H31.3063V32.9265H31.8989V31.6947Z",
    fill: "#F9B256"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7128 31.6947H30.1202V32.9265H30.7128V31.6947Z",
    fill: "#F9B256"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2706 31.6947H33.678V32.9265H34.2706V31.6947Z",
    fill: "#F9B256"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3415 31.6947H27.7484V32.9265H28.3415V31.6947Z",
    fill: "#F9B256"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7485 31.6947H27.1559V32.9265H27.7485V31.6947Z",
    fill: "#FFE167"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9341 31.6947H28.3415V32.9265H28.9341V31.6947Z",
    fill: "#FFE167"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1202 31.6947H29.5272V32.9265H30.1202V31.6947Z",
    fill: "#FFE167"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3063 31.6947H30.7133V32.9265H31.3063V31.6947Z",
    fill: "#FFE167"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4925 31.6947H31.8994V32.9265H32.4925V31.6947Z",
    fill: "#FFE167"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6781 31.6947H33.0851V32.9265H33.6781V31.6947Z",
    fill: "#FFE167"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8638 31.6947H34.2712V32.9265H34.8638V31.6947Z",
    fill: "#FFE167"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8637 31.6947V32.9265H27.1559V31.6947H34.8637ZM35.0935 31.4655H34.8637H27.1559H26.9261V31.6952V32.927V33.1568H27.1559H34.8637H35.0935V32.927V31.6952V31.4655Z",
    fill: "#F5B400"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0855 30.189H32.4924V31.4208H33.0855V30.189Z",
    fill: "#F9B256"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5276 30.189H28.9345V31.4208H29.5276V30.189Z",
    fill: "#F9B256"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8989 30.189H31.3063V31.4208H31.8989V30.189Z",
    fill: "#F9B256"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7128 30.189H30.1202V31.4208H30.7128V30.189Z",
    fill: "#F9B256"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2706 30.189H33.678V31.4208H34.2706V30.189Z",
    fill: "#F9B256"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3415 30.189H27.7484V31.4208H28.3415V30.189Z",
    fill: "#F9B256"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7485 30.189H27.1559V31.4208H27.7485V30.189Z",
    fill: "#FFE167"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9341 30.189H28.3415V31.4208H28.9341V30.189Z",
    fill: "#FFE167"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1202 30.189H29.5272V31.4208H30.1202V30.189Z",
    fill: "#FFE167"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3063 30.189H30.7133V31.4208H31.3063V30.189Z",
    fill: "#FFE167"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4925 30.189H31.8994V31.4208H32.4925V30.189Z",
    fill: "#FFE167"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6781 30.189H33.0851V31.4208H33.6781V30.189Z",
    fill: "#FFE167"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8638 30.189H34.2712V31.4208H34.8638V30.189Z",
    fill: "#FFE167"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8637 30.1889V31.4207H27.1559V30.1889H34.8637ZM35.0935 29.9591H34.8637H27.1559H26.9261V30.1889V31.4207V31.6504H27.1559H34.8637H35.0935V31.4207V30.1889V29.9591Z",
    fill: "#F5B400"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M8.23467 24.4611C8.23467 25.7793 7.16636 26.8471 5.84866 26.8471C4.53095 26.8471 3.46265 25.7788 3.46265 24.4611C3.46265 23.1434 4.53095 22.0756 5.84866 22.0756C7.16636 22.0756 8.23467 23.1439 8.23467 24.4611Z",
    fill: "#E57368"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2358 24.4611C25.2358 25.7793 24.1675 26.8471 22.8498 26.8471C21.532 26.8471 20.4637 25.7788 20.4637 24.4611C20.4637 23.1434 21.532 22.0756 22.8498 22.0756C24.1675 22.0756 25.2358 23.1439 25.2358 24.4611Z",
    fill: "#D3362D"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1253 13.5302C10.1253 13.5302 9.3413 13.3038 8.86164 12.7569C8.49441 12.3381 8.23519 11.4829 8.2347 11.4849C8.23372 11.4829 7.97499 12.3381 7.60776 12.7569C7.12761 13.3038 6.34406 13.5302 6.34406 13.5302C6.34406 13.5302 7.10895 13.8031 7.54197 14.2808C7.97646 14.7605 8.23715 15.5028 8.23765 15.5043C8.23765 15.5043 8.49343 14.76 8.92743 14.2808C9.36044 13.8031 10.1253 13.5302 10.1253 13.5302Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardaverageloansize);
export default __webpack_public_path__ + "static/media/dashboardaverageloansize.4ad9318f004546f0b47f1a5cbec7072f.svg";
export { ForwardRef as ReactComponent };